export default "__VITE_ASSET__Cb2$ybJc__"